import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { darken } from 'polished'
import Anime from '../Anime/Anime'

const Wrapper = styled(Link).attrs({
  className: 'overflow-hidden absolute bottom-0 w-100 flex items-center h3'
})`
  transition: background-color .2s;
  background-color: ${props => props.theme.primaryColor};
  :hover {
    background-color: ${props => darken(0.1, props.theme.primaryColor)}
  }
`

const StepCounter = styled.div.attrs({
  className: 'white w3 w4-ns tc h-100 ph3 ph4-ns f4 flex items-center'
})`
  background-color: ${props => props.theme.secondaryColor}
`

// To force the next button to be off screen on mount.
const defaultStyle = {
  transform: 'translateY(80px)'
}

const NavBar = ({ currentStep, currentStepDone, nextStep, totalSteps }) =>
  <nav className="overflow-hidden absolute bottom-0 w-100 flex items-center h3">
    <StepCounter>
      {currentStep}/{totalSteps}
    </StepCounter>
    <Anime duration={600} translateY={currentStepDone ? 32 : 80}>
      <div className="flex items-center vw-100 h-100" style={defaultStyle}>
        <Wrapper
          to={`/steg/${nextStep}`}
          className="pl4 primary-font-bold white f3 no-underline"
        >
          Neste spørsmål →
        </Wrapper>
      </div>
    </Anime>
  </nav>

NavBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  currentStepDone: PropTypes.bool.isRequired,
  nextStep: PropTypes.string.isRequired,
  totalSteps: PropTypes.number.isRequired
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js